import { IntegrationContainerImageScannerWebComponent } from './component/IntegrationContainerImageScannerWebComponent';
import { WEB_COMPONENT_INTEGRATION_CONTAINER_IMAGE_SCANNER } from '../../../webcomponents.constants';

export { IntegrationContainerImageScannerWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRATION_CONTAINER_IMAGE_SCANNER,
  IntegrationContainerImageScannerWebComponent
);
